export const Loading = () => <p>🌀 Loading...</p>;
